import { render, staticRenderFns } from "./SpilloverPolicy.vue?vue&type=template&id=3f2cd9c4"
import script from "./SpilloverPolicy.vue?vue&type=script&lang=js"
export * from "./SpilloverPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports